document.querySelectorAll('[data-ridge-search]').forEach(form => {
  const input = form.querySelector('[name="q"]');
  const panel = form.querySelector('#RidgeSearchSuggestions');
  const status = form.querySelector('[data-search-status]');
  const dismiss = form.querySelector('[data-search-close]');
  let timer, controller, sequence = 0, selectingSuggestion = false;
  const close = () => {
    panel.hidden = true;
    if (dismiss) dismiss.hidden = true;
    status.textContent = '';
  };
  const cancel = () => { ++sequence; controller?.abort(); clearTimeout(timer); close(); };
  input.addEventListener('input', () => {
    cancel();
    const current = sequence;
    const query = input.value.trim();
    if (query.length < 2) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(form.dataset.suggestUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', 'ridge-predictive');
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '5');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (current !== sequence || !form.contains(document.activeElement)) return;
        const results = html.querySelector('[data-ridge-suggestions]');
        if (!results?.querySelector('li a')) { close(); return; }
        panel.replaceChildren(...results.childNodes);
        panel.hidden = false;
        if (dismiss) dismiss.hidden = false;
        status.textContent = status.dataset.ready;
      } catch (error) { if (current === sequence) close(); }
    }, 250);
  });
  form.addEventListener('keydown', event => {
    if (event.key === 'Escape') { cancel(); input.focus(); event.preventDefault(); return; }
    if (panel.hidden) return;
    const links = Array.from(panel.querySelectorAll('a'));
    const index = links.indexOf(event.target);
    if (event.target === input && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault();
      (event.key === 'ArrowDown' ? links[0] : links.at(-1))?.focus();
    } else if (index >= 0) {
      let next;
      if (event.key === 'ArrowDown') next = links[index + 1] || input;
      if (event.key === 'ArrowUp') next = links[index - 1] || input;
      if (event.key === 'Home') next = links[0];
      if (event.key === 'End') next = links.at(-1);
      if (next) { event.preventDefault(); next.focus(); }
    }
  });
  dismiss?.addEventListener('click', () => { cancel(); input.focus(); });
  form.addEventListener('pointerdown', event => { selectingSuggestion = panel.contains(event.target) || dismiss?.contains(event.target); });
  document.addEventListener('pointerup', () => { selectingSuggestion = false; });
  document.addEventListener('pointercancel', () => { selectingSuggestion = false; if (!form.contains(document.activeElement)) cancel(); });
  document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) cancel(); });
  form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget) && !selectingSuggestion) cancel(); });
  form.addEventListener('submit', cancel);
});
